import React from 'react';
import battleData from '../../data/battles.json';
import { motion, AnimatePresence } from 'framer-motion';

class Battleinfo extends React.Component {
  constructor(props) {
    super(props);
    this.ChangeImg = this.ChangeImg.bind(this);
    this.state = { imageBig: false };
  }

  componentDidMount() {
    this.setState({ imageBig: true });
  }

  componentDidUpdate() {
    this.refs.elem.scrollTop = 0;

  }

  ChangeImg() {
    let ScreenWidthP = window.outerWidth;
    if (ScreenWidthP >= 501) {
      this.setState({ imageBig: !this.state.imageBig });
    }
  }
  render() {
    return (
      <motion.div
        className="battleInfo"
        ref="elem"
        animate={this.props.textRead ? { right: '-550px' } : { right: 0 }}
        transition={{ duration: 0.5 }}
      >
        <div className="info-nav">
          <motion.button
            className="left"
            tabIndex={this.props.textRead ? -1 : 0}
            onClick={this.props.onPrev}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            &#8249;
          </motion.button>
          <div className="count">
            {battleData[this.props.currentBattle].id}/16
          </div>
          <motion.button
            className="right"
            tabIndex={this.props.textRead ? -1 : 0}
            onClick={this.props.onNext}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            &#8250;
          </motion.button>
        </div>
        {battleData[this.props.currentBattle].war != 'Revolutionary War' ? (
          <div className="fiw">{battleData[this.props.currentBattle].war}</div>
        ) : (
            <div className="rev">{battleData[this.props.currentBattle].war}</div>
          )}
        <div className="infoText">
          <div className="battleTitle">
            {battleData[this.props.currentBattle].title}
          </div>
          <div className="battleDate">
            {battleData[this.props.currentBattle].date}
          </div>
          <div className="battleCountry">
            Result: {battleData[this.props.currentBattle].victory}
          </div>
        </div>
        <motion.button
          className="close"
          tabIndex={this.props.textRead ? -1 : 0}
          onClick={this.props.onSelect}>
          &#187;
        </motion.button>
        <img
          className="main_image"
          src={require(`../../images/battle-map/${
            battleData[this.props.currentBattle].largeImage
            }`)}
          onClick={this.ChangeImg}
        />
        <div className="caption">
          {battleData[this.props.currentBattle].caption}
        </div>

        <div className="infoText">
          <div className="battleText">
            {battleData[this.props.currentBattle].info}
            {battleData[this.props.currentBattle].buttonURL != 'null' ? (
              <motion.button
                tabIndex={this.props.textRead ? -1 : 0}
                style={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                onClick={() =>
                  window.open(
                    `https://${battleData[this.props.currentBattle].buttonURL}`,
                    '_blank'
                  )
                }
              >
                Learn More
              </motion.button>
            ) : (
                ''
              )}

            <div className="statsContainer">
              <div className="statsHeader">Opposing Forces</div>
              <div className="flex_half">
                <div className="flag">
                  <img
                    src={require(`../../images/battle-map/${
                      battleData[this.props.currentBattle].combatantOneFlag
                      }`)}
                  />
                </div>
                {battleData[this.props.currentBattle].combatantOne}
              </div>
              <div className="flex_half">
                <div className="flag">
                  <img
                    src={require(`../../images/battle-map/${
                      battleData[this.props.currentBattle].combatantTwoFlag
                      }`)}
                  />
                </div>
                {battleData[this.props.currentBattle].combatantTwo}
              </div>

              <div className="statsHeader">Commanders and Leaders</div>
              <div className="flex_half">
                {battleData[this.props.currentBattle].combatantOneGeneral}
              </div>
              <div className="flex_half">
                {battleData[this.props.currentBattle].combatantTwoGeneral}
              </div>

              <div className="statsHeader">Troop Strength</div>
              <div className="flex_half">
                {battleData[this.props.currentBattle].combatantOneStrength}
              </div>
              <div className="flex_half">
                {battleData[this.props.currentBattle].combatantTwoStrength}
              </div>

              <div className="statsHeader">Casualties and Losses</div>
              <div className="flex_half">
                {battleData[this.props.currentBattle].combatantOneDeaths}
              </div>
              <div className="flex_half">
                {battleData[this.props.currentBattle].combatantTwoDeaths}
              </div>
            </div>
          </div>
        </div>
        <div className="info-nav">
          <motion.button
            className="left"
            tabIndex={this.props.textRead ? -1 : 0}
            onClick={this.props.onPrev}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            &#8249;
          </motion.button>
          <div className="count">
            {battleData[this.props.currentBattle].id}/16
          </div>
          <motion.button
            className="right"
            tabIndex={this.props.textRead ? -1 : 0}
            onClick={this.props.onNext}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            &#8250;
          </motion.button>
        </div>
        <motion.div
          className="enlarged"
          onClick={this.ChangeImg}
          animate={
            this.state.imageBig
              ? {
                opacity: 0,
                pointerEvents: 'false',
                display: 'none',
              }
              : {
                opacity: 1,
                pointerEvents: 'true',
                display: 'flex',
              }
          }
        >
          <div className="constrain">
            <img
              src={require(`../../images/battle-map/${
                battleData[this.props.currentBattle].largeImage
                }`)}
            />
            <div className="caption_large">
              {battleData[this.props.currentBattle].caption}
            </div>
          </div>
        </motion.div>
      </motion.div>
    );
  }
}

export default Battleinfo;
